<script setup lang="ts">
import ModelSlider from '~/components/sliders/ModelSlider.vue';
import type { IProductModel } from '~/interfaces/product/IProductModel';

const props = defineProps<{
  canonicalProductId: number
  productModelCollection?: IProductModel[]
}>()

const {
  productModelCollection,
  canonicalProductId
} = toRefs(props)
</script>

<template>
  <div
v-if="productModelCollection && productModelCollection.length > 0"
       class="product-model-collection"
       data-update-bloc="model"
       :data-current-product-color-id="canonicalProductId">
    <ModelSlider :product-model-collection="productModelCollection"/>
  </div>
</template>
